import { tr, usePartnerTranslation } from "../lib/language";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HardHat } from "lucide-react";

const prettify = (pathname) => {
  if (!pathname || pathname === "/") return "Page";
  const segs = pathname.split("/").filter(Boolean);
  const last = segs[segs.length - 1] || "page";
  return last
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export const DummyPage = ({ title }) => {
  usePartnerTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = title || prettify(location.pathname);

  return (
    <main
      data-testid="dummy-page"
      className="flex flex-1 items-center justify-center px-4 py-24"
    >
      <div className="humrahe-card max-w-xl px-10 py-14 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[rgba(255,87,87,0.11)]">
          <HardHat className="h-6 w-6 text-[#FF5757]" />
        </div>
        <h1
          data-testid="dummy-title"
          className="text-2xl font-bold text-[#0F1115] sm:text-3xl"
        >
          {pageTitle}
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-[#6B7280]">{tr("This page is under construction. Check back later.")}</p>
        <button
          data-testid="dummy-back-btn"
          onClick={() => navigate(-1)}
          className="humrahe-btn-primary mt-8 inline-flex h-11 items-center justify-center rounded-lg px-5 text-sm font-semibold"
        >{tr("Go back")}</button>
      </div>
    </main>
  );
};

export default DummyPage;
